@if (loading) {
  <div style="width: 100%;text-align: center;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
    <p>Načítání</p>
  </div>
}
@else {
  @if (activity.type == 1) {
    <div class="content-podminky">
      <form [formGroup]="termsForm">
        <span [innerHTML]="activity.params.content1"></span>
        <mat-form-field class="termInput">
          <mat-label>Zadejte vaše jméno</mat-label>
          <input formControlName="name" name="name" type="text" matInput>
        </mat-form-field>
        <span [innerHTML]="activity.params.content2"></span>
        <mat-form-field class="termInput">
          <mat-label>Zadejte vaši adresu</mat-label>
          <input formControlName="address" name="address" type="text" matInput>
        </mat-form-field>
        <span [innerHTML]="activity.params.content3"></span>
        <mat-form-field class="termInput">
          <mat-label>Zadejte vaše datum narození</mat-label>
          <input formControlName="borndate" name="borndate" type="date" matInput>
        </mat-form-field>
        <div [innerHTML]="activity.params.content4 + ' ' + activity.params.reward1
        + activity.params.content5 + ' ' + activity.params.reward2
        + activity.params.content6 + ' ' + activity.params.reward3
        + activity.params.content7 + activity.params.content8"></div>
        <div class="endBtn">
          <button class="backBtn" mat-button (click)="goBack()"><mat-icon slot="start">arrow_back</mat-icon>Zpět</button>
          <button type="submit" [disabled]="!termsForm.valid || butLoading" class="agreeBtn" mat-button (click)="completeActivity()">
            @if (butLoading) {
              <ng-container>
                <mat-spinner [diameter]="20" slot="start" color="primary"></mat-spinner>
              </ng-container>
            } @else {
              <ng-container>
                Souhlasím
              </ng-container>
            }
          </button>
          @if (!termsForm.valid) {
            <br>
            <small class="errorMsg">* Vyplňte prosím všechna povinná pole.</small>
          }
      </div>
      </form>
    </div>
  }
  @if (activity.type == 3) {
    <app-aichat [aid]="actId"></app-aichat>
  }
  @if (activity.type == 5) {
    <app-mic-check [aid]="actId" [complete]="activity.state == 'complete'"></app-mic-check>
  }
}
